<div class="mt-4 mx-4">

  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

  <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="mobile-users-tab">
    <div class="card shadow-sm border-0">
      <div class="card-body">

        <!-- ── SEARCH + FUNNEL ── -->
        <div class="row align-items-center mb-3">
          <div class="col-12">
            <div class="d-flex gap-2 align-items-stretch">

              <!-- Search -->
              <div class="col-md-9 col-sm-12 mb-2 mb-md-0">
                <div class="position-relative">
                  <input id="searchUser" type="text" class="form-control user-search-input shadow-none"
                    placeholder="Type here..." [(ngModel)]="searchText" (input)="performSearch()" />
                  <span class="search-icon">
                    <i class="bi bi-search"></i>
                  </span>
                </div>
              </div>

              <!-- Server Filter Button & Dropdown -->
              <div class="flex-shrink-0 advanced-filter-wrapper">
                <app-filter-panel #filterPanel title="Advanced Filter" [fields]="filterFields"
                  (filterApplied)="onFilter($event)" (filterCleared)="onClear()">
                </app-filter-panel>
              </div>
            </div>
          </div>
        </div>

        <!-- ── TOP FILTER BAR ── -->
        <div class="row g-2 align-items-end mb-3 mt-2">

          <!-- Employer (Company) -->
          <!-- <div class="col-12 col-xl-4">
            <label class="filter-bar-label">Employer</label>
            <select class="form-select filter-bar-select shadow-none" [(ngModel)]="filterCompanyId"
              (change)="onTopFilterChange()">
              <option value="" selected>All Employers</option>
              <option *ngFor="let c of companies" [ngValue]="c.companyId">{{ c.companyName }} ({{ c.companyId }})</option>
            </select>
          </div> -->

          <div class="col-12 col-xl-4">
            <label class="filter-bar-label">Employer</label>

            <div class="searchable-dropdown">
              <!-- Visible Search Input -->
              <div class="dropdown-input-wrapper">
                <input type="text" class="form-control shadow-none input-text" [value]="getSelectedCompanyName()"
                  (input)="onFilterCompanySearchChange($event)" (focus)="openCompanyDropdown()" (blur)="onCompanyBlur()"
                  placeholder="All Employers" autocomplete="off" #companySearchInput>
                <span class="input-group-text"><i class="bi bi-chevron-down"></i></span>
              </div>

              <!-- Dropdown Options List -->
              <div class="dropdown-list" *ngIf="companyDropdownOpen && filteredCompanies().length > 0">
                <!-- "All Employers" default option -->
                <div class="dropdown-item" [class.selected]="!filterCompanyId" (mousedown)="selectCompany(null)">
                  <span class="bank-name">All Employers</span>
                </div>
                <div class="dropdown-item" *ngFor="let c of filteredCompanies()" (mousedown)="selectCompany(c)"
                  [class.selected]="filterCompanyId === c.companyId">
                  <span class="bank-name">{{ c.companyName }} ({{ c.companyId }})</span>
                </div>
              </div>

              <!-- No Results Message -->
              <div class="dropdown-list no-results" *ngIf="companyDropdownOpen && filteredCompanies().length === 0">
                <div class="dropdown-item">No employers found</div>
              </div>
            </div>
          </div>

          <!-- User Type -->
          <div class="col-12 col-xl-2">
            <label class="filter-bar-label">User Type</label>
            <select class="form-select filter-bar-select shadow-none" [(ngModel)]="filterUserType"
              (change)="onTopFilterChange()">
              <option value="">All Users</option>
              <option value="Linked">Wage Accessed</option>
              <option value="Unlinked">Standalone</option>
            </select>
          </div>

          <!-- Start Date -->
          <div class="col-12 col-xl-2">
            <label class="filter-bar-label">From Date</label>
            <input type="date" class="form-control filter-bar-select shadow-none" [(ngModel)]="filterStartDate"
              [max]="todayStr" (change)="onTopFilterChange()" />
          </div>

          <!-- End Date -->
          <div class="col-12 col-xl-2">
            <label class="filter-bar-label">To Date</label>
            <input type="date" class="form-control filter-bar-select shadow-none" [(ngModel)]="filterEndDate"
              [max]="todayStr" [min]="filterStartDate || ''" (change)="onTopFilterChange()" />
          </div>

          <!-- Reset -->
          <div class="col-12 col-xl-auto">
            <button type="button" class="btn btn-secondary w-100" [disabled]="!isTopFilterApplied"
              (click)="resetTopFilter()">
              <i class="bi bi-arrow-counterclockwise me-1"></i>Reset
            </button>
          </div>
        </div>

        <!-- States -->
        <div *ngIf="isLoading" class="text-muted">Loading users...</div>
        <!-- Empty State -->
        <div *ngIf="(error || !isLoading && filteredMobileUsers.length === 0) && !error" class="text-center py-5">
          <i class="bi bi-inbox fs-1 text-muted mb-3"></i>
          <p class="text-muted">No Mobile Users Found.</p>
        </div>

        <!-- Table -->
        <div *ngIf="filteredMobileUsers.length > 0 && !error" class="table-responsive-wrapper">
          <table class="table table-striped">
            <thead>
              <tr>
                <th class="table-title text-start">CID</th>
                <th class="table-title text-start">First Name</th>
                <th class="table-title text-start">Last Name</th>
                <th class="table-title text-start">Email Address</th>
                <th class="table-title text-center">Verification Status</th>
                <th class="table-title text-center">Wage Access</th>
                <th class="table-title text-center">Status</th>
                <th class="table-title text-center">Login Access</th>
                <th class="table-title text-center">
                  <i class="bi bi-eye"></i>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let user of filteredMobileUsers">
                <td class="table-data-text text-start">{{ user.cid }}</td>
                <td class="table-data-text text-start">{{ user.firstName | titlecase }}</td>
                <td class="table-data-text text-start">{{ user.lastName | titlecase }}</td>
                <td class="table-data-text text-start">{{ user.email }}</td>
                <!-- Verification -->
                <td class="table-data-text text-center">
                  <span class="badge rounded-pill text-nowrap"
                    [ngClass]="user.isVerified ? 'bg-success' : 'bg-secondary'"
                    [attr.title]="user.isVerified ? 'Verified' : 'Not Verified'">
                    <i class="bi bi-shield-check me-1"></i>
                    {{ user.isVerified ? 'Verified' : 'Not Verified' }}
                  </span>
                </td>

                <!-- Wage Access -->
                <td class="table-data-text text-center">
                  <span class="badge rounded-pill text-nowrap"
                    [ngClass]="user.isWageAccessAllowed ? 'bg-success' : 'bg-secondary'"
                    [attr.title]="user.isWageAccessAllowed ? 'Granted' : 'Not Granted'">
                    <i class="bi bi-cash-coin me-1"></i>
                    {{ user.isWageAccessAllowed ? 'Granted' : 'Not Granted' }}
                  </span>
                </td>
                <td class="table-data-text text-center">
                  <span class="badge rounded-pill text-nowrap" [ngClass]="user.linkStatus ? 'bg-success' : 'bg-secondary'"
                    [attr.title]="user.linkStatus ? 'Active' : 'Inactive'">
                    {{ user.linkStatus ? 'Active' : 'Inactive' }}
                  </span>
                </td>
                <!-- Enable / Disable toggle -->
                <td class="table-data-text text-end">
                  <button
                    class="user-toggle-btn"
                    [class.toggle-enabled]="user.isUserActive"
                    [class.toggle-disabled]="!user.isUserActive"
                    [disabled]="togglingCids.has(user.cid)"
                    [attr.title]="user.isUserActive ? 'Click to Disable' : 'Click to Enable'"
                    (click)="toggleUserStatus(user)">
                    <span class="toggle-track">
                      <span class="toggle-thumb"></span>
                    </span>
                    <span class="toggle-label">{{ togglingCids.has(user.cid) ? '...' : (user.isUserActive ? 'Enabled' : 'Disabled') }}</span>
                  </button>
                </td>
                <td class="table-data-text text-center">
                  <button class="btn p-0" style="background: none; border: none;" data-bs-toggle="offcanvas"
                    data-bs-target="#userViewOffcanvas" aria-controls="userViewOffcanvas" (click)="openViewUser(user)">
                    <i class="bi bi-arrow-right" style="color: var(--primary-color); font-size: 1.2rem;"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Pagination toolbar -->
          <app-paginator [serverSide]="true" [totalItems]="totalMobileUsers" [pageSize]="pageSize"
            [pageSizeOptions]="[5, 10, 20, 50]" (pageChangeServer)="onMobileUserPageChange($event)">
          </app-paginator>

        </div>

      </div>
    </div>
  </div>
</div>

<!-- Block Reason Modal -->
<div class="block-reason-overlay" *ngIf="blockReasonModalUser" (click)="cancelDisable()"></div>
<div class="block-reason-modal" *ngIf="blockReasonModalUser" role="dialog" aria-modal="true"
  aria-labelledby="blockReasonTitle">

  <div class="br-modal-banner d-flex align-items-center gap-3">
    <div class="br-icon-wrap">
      <i class="bi bi-slash-circle"></i>
    </div>
    <div>
      <h5 class="mb-0" id="blockReasonTitle">Block User</h5>
      <small>{{ blockReasonModalUser.firstName | titlecase }} {{ blockReasonModalUser.lastName | titlecase }}</small>
    </div>
  </div>

  <div class="modal-body px-4 py-3">
    <p class="br-body-text">
      Enter a reason for blocking
      <strong>{{ blockReasonModalUser.firstName | titlecase }} {{ blockReasonModalUser.lastName | titlecase }}</strong>.
    </p>

    <label for="blockReasonInput" class="form-label fw-semibold" style="font-size: 0.875rem;">
      Block Reason <span class="text-danger">*</span>
    </label>

    <div class="block-reason-chips">
      <button type="button" class="reason-chip" *ngFor="let reason of quickReasons" (click)="selectQuickReason(reason)">
        {{ reason }}
      </button>
    </div>

    <textarea id="blockReasonInput" class="form-control shadow-none br-textarea" rows="2" maxlength="50"
      placeholder="Enter reason (max 50 characters)" [(ngModel)]="blockReasonInput"
      (ngModelChange)="blockReasonError = ''"></textarea>
    <div class="d-flex justify-content-between mt-1">
      <small class="text-danger">{{ blockReasonError }}</small>
      <small [ngClass]="blockReasonInput.length >= 50 ? 'text-danger fw-semibold' : 'text-muted'">
        {{ blockReasonInput.length }}/50
      </small>
    </div>

    <div class="br-warn-note mt-3">
      <i class="bi bi-exclamation-triangle-fill"></i>
      <span>This user will lose login access immediately and won't be able to log in until unblocked.</span>
    </div>
  </div>

  <div class="modal-footer border-0 px-4 pb-4 pt-1 gap-2">
    <button type="button" class="btn br-btn-cancel" (click)="cancelDisable()">Cancel</button>
    <button type="button" class="btn br-btn-block" [disabled]="!blockReasonInput.trim()" (click)="confirmDisable()">
      <i class="bi bi-slash-circle me-1"></i>Block User
    </button>
  </div>

</div>

<!-- Block Reason Modal -->
<div class="block-reason-overlay" *ngIf="blockReasonModalUser" (click)="cancelDisable()"></div>
<div class="block-reason-modal" *ngIf="blockReasonModalUser" role="dialog" aria-modal="true" aria-labelledby="blockReasonTitle">

  <div class="br-modal-banner d-flex align-items-center gap-3">
    <div class="br-icon-wrap">
      <i class="bi bi-slash-circle"></i>
    </div>
    <div>
      <h5 class="mb-0" id="blockReasonTitle">Block User</h5>
      <small>{{ blockReasonModalUser.firstName | titlecase }} {{ blockReasonModalUser.lastName | titlecase }}</small>
    </div>
  </div>

  <div class="modal-body px-4 py-3">
    <p class="br-body-text">
      Enter a reason for blocking
      <strong>{{ blockReasonModalUser.firstName | titlecase }} {{ blockReasonModalUser.lastName | titlecase }}</strong>.
    </p>

    <label for="blockReasonInput" class="form-label fw-semibold" style="font-size: 0.875rem;">
      Block Reason <span class="text-danger">*</span>
    </label>

    <div class="block-reason-chips">
      <button type="button" class="reason-chip" *ngFor="let reason of quickReasons" (click)="selectQuickReason(reason)">
        {{ reason }}
      </button>
    </div>

    <textarea id="blockReasonInput" class="form-control shadow-none br-textarea" rows="2" maxlength="50"
      placeholder="Enter reason (max 50 characters)" [(ngModel)]="blockReasonInput"
      (ngModelChange)="blockReasonError = ''"></textarea>
    <div class="d-flex justify-content-between mt-1">
      <small class="text-danger">{{ blockReasonError }}</small>
      <small [ngClass]="blockReasonInput.length >= 50 ? 'text-danger fw-semibold' : 'text-muted'">
        {{ blockReasonInput.length }}/50
      </small>
    </div>

    <div class="br-warn-note mt-3">
      <i class="bi bi-exclamation-triangle-fill"></i>
      <span>This user will lose login access immediately and won't be able to log in until unblocked.</span>
    </div>
  </div>

  <div class="modal-footer border-0 px-4 pb-4 pt-1 gap-2">
    <button type="button" class="btn br-btn-cancel" (click)="cancelDisable()">Cancel</button>
    <button type="button" class="btn br-btn-block" [disabled]="!blockReasonInput.trim()" (click)="confirmDisable()">
      <i class="bi bi-slash-circle me-1"></i>Block User
    </button>
  </div>

</div>

<div #userViewOffcanvasEl class="offcanvas offcanvas-end w-70" tabindex="-1" id="userViewOffcanvas"
  aria-labelledby="userViewOffcanvasLabel" data-bs-backdrop="static" data-bs-keyboard="false">

  <div class="offcanvas-header">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-10 d-flex align-items-center">
          <h5 class="offcanvas-title d-flex align-items-center gap-2 mb-0" id="userViewOffcanvasLabel">
            <i class="bi fs-5 bi-person"></i>
            User Details
          </h5>
        </div>
        <div class="col-2 text-end">
          <span type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></span>
        </div>
      </div>
    </div>
  </div>

  <div class="offcanvas-body">
    <div *ngIf="selectedUser as u">

      <!-- TOP LINE: CID + Created (with copy) -->
      <div class="d-flex flex-wrap gap-3 mb-2">
        <span class="badge rounded-pill bg-light text-dark border">
          CID: {{ u.cid }}
          <i class="bi bi-clipboard ms-2 align-baseline" style="cursor: pointer" role="button" tabindex="0"
            aria-label="Copy CID" (click)="copy(toStr(u.cid))" (keydown.enter)="copy(toStr(u.cid))"
            (keydown.space)="copy(toStr(u.cid))"></i>
        </span>

        <span class="badge rounded-pill bg-light text-dark border">
          Created: {{ (u.createdAt | date: 'yyyy-MM-dd, h:mm:ss a') || '-' }}
          <i class="bi bi-clipboard ms-2 align-baseline" style="cursor: pointer" role="button" tabindex="0"
            aria-label="Copy Created At" (click)="copy(formatDateTime(u.createdAt) || '')"
            (keydown.enter)="copy(formatDateTime(u.createdAt) || '')"
            (keydown.space)="copy(formatDateTime(u.createdAt) || '')"></i>
        </span>
      </div>

      <!-- HEADER: Name + quick chips (copy on email/phone/wallet) -->
      <div class="d-flex align-items-center gap-3 mb-3">
        <div class="flex-grow-1">
          <div class="fw-semibold" style="font-size:1.15rem;">
            {{ fullName(u) | titlecase }}
            <span class="badge rounded-pill text-nowrap" [ngClass]="u.linkStatus ? 'bg-success' : 'bg-secondary'"
              [attr.title]="u.linkStatus ? 'Active' : 'Inactive'">
              {{ u.linkStatus ? 'Active' : 'Inactive' }}
            </span>
            <span *ngIf="!u.isUserActive" class="badge rounded-pill text-nowrap ms-1"
              style="background:#ef4444; color:#fff;">
              <i class="bi bi-slash-circle me-1"></i>Suspended
            </span>
          </div>
          <div class="d-flex flex-wrap gap-2 mt-2">
            <span class="badge rounded-pill bg-secondary-subtle text-dark border">
              <i class="bi bi-envelope me-1"></i>{{ u.email || '—' }}
              <i class="bi bi-clipboard ms-2 align-baseline" style="cursor: pointer" role="button" tabindex="0"
                aria-label="Copy Email" (click)="copy(u.email || '')" (keydown.enter)="copy(u.email || '')"
                (keydown.space)="copy(u.email || '')"></i>
            </span>

            <span class="badge rounded-pill bg-secondary-subtle text-dark border">
              <i class="bi bi-telephone me-1"></i>{{ u.mobileNumber || '—' }}
              <i class="bi bi-clipboard ms-2 align-baseline" style="cursor: pointer" role="button" tabindex="0"
                aria-label="Copy Mobile" (click)="copy(u.mobileNumber || '')"
                (keydown.enter)="copy(u.mobileNumber || '')" (keydown.space)="copy(u.mobileNumber || '')"></i>
            </span>

            <span class="badge rounded-pill" [ngClass]="u.isWageAccessAllowed ? 'bg-success' : 'bg-secondary'">
              <i class="bi bi-cash-coin me-1"></i>{{ u.isWageAccessAllowed ? 'Wage Access: Granted' : 'Wage Access: Not
              Granted' }}
            </span>

            <span class="badge rounded-pill" [ngClass]="u.isVerified ? 'bg-success' : 'bg-secondary'">
              <i class="bi bi-shield-check me-1"></i>{{ u.isVerified ? 'Verified' : 'Not Verified' }}
            </span>

            <span class="badge rounded-pill bg-light text-dark border">
              <i class="bi bi-wallet2 me-1"></i>
              {{ u.walletLimit !== null && u.walletLimit !== undefined ? (u.walletLimit | currency:'LKR
              ':'symbol':'1.2-2') : 'Wallet: —' }}
              <i class="bi bi-clipboard ms-2 align-baseline" style="cursor: pointer" role="button" tabindex="0"
                aria-label="Copy Wallet Limit" (click)="copy(toStr(u.walletLimit))"
                (keydown.enter)="copy(toStr(u.walletLimit))" (keydown.space)="copy(toStr(u.walletLimit))"></i>
            </span>
          </div>
        </div>
      </div>

      <hr class="mt-2 mb-3" />

      <!-- Suspended / Block Reason banner -->
      <div class="br-suspended-banner" *ngIf="!u.isUserActive && u.blockReason">
        <div class="br-suspended-icon"><i class="bi bi-slash-circle-fill"></i></div>
        <div>
          <div class="br-suspended-label">Account Suspended</div>
          <div class="br-suspended-reason">{{ u.blockReason }}</div>
        </div>
      </div>

      <!-- PERSONAL: DOB (copy) -->
      <div class="row g-3">
        <div class="col-md-4">
          <div class="p-3 rounded-3 border">
            <div class="small text-muted mb-1"><i class="bi bi-calendar3 me-1"></i>Date of Birth</div>
            <div class="fw-semibold d-flex align-items-center">
              <span>{{ formatDate(u.dob) || '—' }}</span>
              <i class="bi bi-clipboard ms-2 align-baseline" style="cursor: pointer" role="button" tabindex="0"
                aria-label="Copy Date of Birth" (click)="copy(formatDate(u.dob) || '')"
                (keydown.enter)="copy(formatDate(u.dob) || '')" (keydown.space)="copy(formatDate(u.dob) || '')"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- ADDRESS (includes city, district, province, country) -->
      <h6 class="text-muted mt-4">Address</h6>
      <hr class="mb-3" />
      <div class="p-3 rounded-3 border">
        <div class="d-flex align-items-start">
          <i class="bi bi-house-door me-2 mt-1"></i>
          <div>
            <div class="fw-semibold mb-1 d-flex align-items-center">
              <span>{{ u.address || '—' }}</span>
              <i class="bi bi-clipboard ms-2 align-baseline" style="cursor: pointer" role="button" tabindex="0"
                aria-label="Copy Address" (click)="copy(u.address || '')" (keydown.enter)="copy(u.address || '')"
                (keydown.space)="copy(u.address || '')"></i>
            </div>
            <div class="text-muted small d-flex align-items-center">
              <span>{{ joinAddressRegion(u.city, u.district, u.province, u.country) || '—' }}</span>
              <i class="bi bi-clipboard ms-2 align-baseline" style="cursor: pointer" role="button" tabindex="0"
                aria-label="Copy Region"
                (click)="copy(joinAddressRegion(u.city, u.district, u.province, u.country) || '')"
                (keydown.enter)="copy(joinAddressRegion(u.city, u.district, u.province, u.country) || '')"
                (keydown.space)="copy(joinAddressRegion(u.city, u.district, u.province, u.country) || '')"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- COMPANY (only if wage access) — copy on all values -->
      <ng-container *ngIf="u.isWageAccessAllowed">
        <h6 class="text-muted mt-4">Company</h6>
        <hr class="mb-3" />
        <div class="row g-3">
          <div class="col-md-6">
            <div class="p-3 rounded-3 border h-100">
              <div class="small text-muted mb-1"><i class="bi bi-tags me-1"></i>CIXOR Ref No.</div>
              <div class="fw-semibold d-flex align-items-center">
                <span>{{ u.cixorReferenceNumber || '—' }}</span>
                <i class="bi bi-clipboard ms-2 align-baseline" style="cursor: pointer" role="button" tabindex="0"
                  aria-label="Copy CIXOR Reference" (click)="copy(u.cixorReferenceNumber || '')"
                  (keydown.enter)="copy(u.cixorReferenceNumber || '')"
                  (keydown.space)="copy(u.cixorReferenceNumber || '')"></i>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="p-3 rounded-3 border h-100">
              <div class="small text-muted mb-1"><i class="bi bi-hash me-1"></i>Company ID</div>
              <div class="fw-semibold d-flex align-items-center">
                <span>{{ u.companyId || '—' }}</span>
                <i class="bi bi-clipboard ms-2 align-baseline" style="cursor: pointer" role="button" tabindex="0"
                  aria-label="Copy Company ID" (click)="copy(toStr(u.companyId))"
                  (keydown.enter)="copy(toStr(u.companyId))" (keydown.space)="copy(toStr(u.companyId))"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="row g-3 mt-1">
          <div class="col-md-6">
            <div class="p-3 rounded-3 border h-100">
              <div class="small text-muted mb-1"><i class="bi bi-building me-1"></i>Company Name</div>
              <div class="fw-semibold d-flex align-items-center">
                <span>{{ u.companyName || '—' }}</span>
                <i class="bi bi-clipboard ms-2 align-baseline" style="cursor: pointer" role="button" tabindex="0"
                  aria-label="Copy Company Name" (click)="copy(u.companyName || '')"
                  (keydown.enter)="copy(u.companyName || '')" (keydown.space)="copy(u.companyName || '')"></i>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="p-3 rounded-3 border h-100">
              <div class="small text-muted mb-1"><i class="bi bi-megaphone me-1"></i>Trading Name</div>
              <div class="fw-semibold d-flex align-items-center">
                <span>{{ u.companyTradingName || '—' }}</span>
                <i class="bi bi-clipboard ms-2 align-baseline" style="cursor: pointer" role="button" tabindex="0"
                  aria-label="Copy Trading Name" (click)="copy(u.companyTradingName || '')"
                  (keydown.enter)="copy(u.companyTradingName || '')"
                  (keydown.space)="copy(u.companyTradingName || '')"></i>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Per Day Wage Details — copy on all values -->
      <ng-container *ngIf="u.userType === 'Linked'">
        <h6 class="text-muted mt-4">Per Day Wage Details</h6>
        <hr class="mb-3" />

        <!-- Row 1: Basic, Allowances, Deductions -->
        <div class="row g-3">
          <div class="col-md-4">
            <div class="p-3 rounded-3 border h-100">
              <div class="small text-muted mb-1"><i class="bi bi-cash-stack me-1"></i>Total Basic Salary</div>
              <div class="fw-semibold d-flex align-items-center">
                <span>{{ (u.totalBasic | currency:'LKR ':'symbol':'1.2-2') || '—' }}</span>
                <i class="bi bi-clipboard ms-2 align-baseline" style="cursor:pointer" role="button" tabindex="0"
                  aria-label="Copy Basic Salary" (click)="copy(toStr(u.totalBasic))"
                  (keydown.enter)="copy(toStr(u.totalBasic))" (keydown.space)="copy(toStr(u.totalBasic))"></i>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="p-3 rounded-3 border h-100">
              <div class="small text-muted mb-1"><i class="bi bi-plus-circle me-1"></i>Total Allowances</div>
              <div class="fw-semibold d-flex align-items-center">
                <span>{{ (u.totalallowance | currency:'LKR ':'symbol':'1.2-2') || '—' }}</span>
                <i class="bi bi-clipboard ms-2 align-baseline" style="cursor:pointer" role="button" tabindex="0"
                  aria-label="Copy Allowances" (click)="copy(toStr(u.totalallowance))"
                  (keydown.enter)="copy(toStr(u.totalallowance))" (keydown.space)="copy(toStr(u.totalallowance))"></i>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="p-3 rounded-3 border h-100">
              <div class="small text-muted mb-1"><i class="bi bi-dash-circle me-1"></i>Total Deductions</div>
              <div class="fw-semibold d-flex align-items-center">
                <span>{{ (u.totalDeduction | currency:'LKR ':'symbol':'1.2-2') || '—' }}</span>
                <i class="bi bi-clipboard ms-2 align-baseline" style="cursor:pointer" role="button" tabindex="0"
                  aria-label="Copy Deductions" (click)="copy(toStr(u.totalDeduction))"
                  (keydown.enter)="copy(toStr(u.totalDeduction))" (keydown.space)="copy(toStr(u.totalDeduction))"></i>
              </div>
            </div>
          </div>
        </div>

        <!-- Row 2: Per Day Amount, Maximum Allowed Amount, Pay Day Eligible -->
        <div class="row g-3 mt-1">
          <div class="col-md-6">
            <div class="p-3 rounded-3 border h-100">
              <div class="small text-muted mb-1"><i class="bi bi-calendar-day me-1"></i>Per Day Amount</div>
              <div class="fw-semibold d-flex align-items-center">
                <span>{{ (u.perDayAmount | currency:'LKR ':'symbol':'1.2-2') || '—' }}</span>
                <i class="bi bi-clipboard ms-2 align-baseline" style="cursor:pointer" role="button" tabindex="0"
                  aria-label="Copy Per Day Amount" (click)="copy(toStr(u.perDayAmount))"
                  (keydown.enter)="copy(toStr(u.perDayAmount))" (keydown.space)="copy(toStr(u.perDayAmount))"></i>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="p-3 rounded-3 border h-100">
              <div class="small text-muted mb-1"><i class="bi bi-calendar-day me-1"></i>Maximum Allowed Amount <span class="text-secondary">({{ u.earnWageWithdrawalAllowPercentage != null ? u.earnWageWithdrawalAllowPercentage + '% of Basic Salary' : '—' }})</span></div>
              <div class="fw-semibold d-flex align-items-center">
                <span>{{ (u.totalBasic != null && u.earnWageWithdrawalAllowPercentage != null) ? ((u.totalBasic * u.earnWageWithdrawalAllowPercentage / 100) | currency:'LKR ':'symbol':'1.2-2') : '—' }}</span>
                <i class="bi bi-clipboard ms-2 align-baseline" style="cursor:pointer" role="button" tabindex="0"
                  aria-label="Copy Maximum Allowed Amount" (click)="copy(toStr(u.totalBasic != null && u.earnWageWithdrawalAllowPercentage != null ? u.totalBasic * u.earnWageWithdrawalAllowPercentage / 100 : null))"
                  (keydown.enter)="copy(toStr(u.totalBasic != null && u.earnWageWithdrawalAllowPercentage != null ? u.totalBasic * u.earnWageWithdrawalAllowPercentage / 100 : null))"
                  (keydown.space)="copy(toStr(u.totalBasic != null && u.earnWageWithdrawalAllowPercentage != null ? u.totalBasic * u.earnWageWithdrawalAllowPercentage / 100 : null))"></i>
              </div>
            </div>
          </div>
          <!--<div class="col-md-6">
            <div class="p-3 rounded-3 border h-100">
              <div class="small text-muted mb-1"><i class="bi bi-check-circle me-1"></i>Pay Day Eligible</div>
              <div class="fw-semibold">
                <span class="badge rounded-pill" [class.bg-success-subtle]="u.payDayEligible"
                  [class.text-success]="u.payDayEligible" [class.bg-danger-subtle]="!u.payDayEligible"
                  [class.text-danger]="!u.payDayEligible">
                  {{ u.payDayEligible ? 'Eligible' : 'Not Eligible' }}
                </span>
              </div>
            </div>
          </div>-->
        </div>

        <!-- Row 3: Withdrawal Percentage, Withdrawal Starting Date -->
        <div class="row g-3 mt-1">
          <div class="col-md-6">
            <div class="p-3 rounded-3 border h-100">
              <div class="small text-muted mb-1"><i class="bi bi-percent me-1"></i>Earn Wage Withdrawal Allowed %</div>
              <div class="fw-semibold d-flex align-items-center">
                <span>{{ u.earnWageWithdrawalAllowPercentage != null ? (u.earnWageWithdrawalAllowPercentage + '%') : '—'
                  }}</span>
                <i class="bi bi-clipboard ms-2 align-baseline" style="cursor:pointer" role="button" tabindex="0"
                  aria-label="Copy Withdrawal Percentage" (click)="copy(toStr(u.earnWageWithdrawalAllowPercentage))"
                  (keydown.enter)="copy(toStr(u.earnWageWithdrawalAllowPercentage))"
                  (keydown.space)="copy(toStr(u.earnWageWithdrawalAllowPercentage))"></i>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="p-3 rounded-3 border h-100">
              <div class="small text-muted mb-1"><i class="bi bi-calendar-check me-1"></i>Earn Wage Withdrawal Starting
                Date
              </div>
              <div class="fw-semibold d-flex align-items-center">
                <span>{{ u.earnWageWithdrawalStartingDate ? (u.earnWageWithdrawalStartingDate) : '—'
                  }}</span>
                <i class="bi bi-clipboard ms-2 align-baseline" style="cursor:pointer" role="button" tabindex="0"
                  aria-label="Copy Withdrawal Starting Date" (click)="copy(u.earnWageWithdrawalStartingDate || '')"
                  (keydown.enter)="copy(u.earnWageWithdrawalStartingDate || '')"
                  (keydown.space)="copy(u.earnWageWithdrawalStartingDate || '')"></i>
              </div>
            </div>
          </div>
        </div>

        <!-- Row 4: Salary Cycle Start Date, Salary Cycle End Date -->
        <div class="row g-3 mt-1">
          <div class="col-md-6">
            <div class="p-3 rounded-3 border h-100">
              <div class="small text-muted mb-1"><i class="bi bi-calendar-event me-1"></i>Salary Cycle Start Date</div>
              <div class="fw-semibold d-flex align-items-center">
                <span>{{ u.salaryCycleStartDate ? (u.salaryCycleStartDate) : '—' }}</span>
                <i class="bi bi-clipboard ms-2 align-baseline" style="cursor:pointer" role="button" tabindex="0"
                  aria-label="Copy Salary Cycle Start Date" (click)="copy(u.salaryCycleStartDate || '')"
                  (keydown.enter)="copy(u.salaryCycleStartDate || '')"
                  (keydown.space)="copy(u.salaryCycleStartDate || '')"></i>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="p-3 rounded-3 border h-100">
              <div class="small text-muted mb-1"><i class="bi bi-calendar-x me-1"></i>Salary Cycle End Date</div>
              <div class="fw-semibold d-flex align-items-center">
                <span>{{ u.salaryCycleEndDate ? (u.salaryCycleEndDate) : '—' }}</span>
                <i class="bi bi-clipboard ms-2 align-baseline" style="cursor:pointer" role="button" tabindex="0"
                  aria-label="Copy Salary Cycle End Date" (click)="copy(u.salaryCycleEndDate || '')"
                  (keydown.enter)="copy(u.salaryCycleEndDate || '')"
                  (keydown.space)="copy(u.salaryCycleEndDate || '')"></i>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <hr />
    </div>
  </div>
</div>
